import { render, staticRenderFns } from "./VSearchBox.vue?vue&type=template&id=55f763f8&"
import script from "./VSearchBox.vue?vue&type=script&lang=js&"
export * from "./VSearchBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports